import { IWorkTime } from '../../models/investor/response';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const formatToHHMM = (dateString: string): string => {
    const date = dayjs(dateString);

    if (!date.isValid()) {
        throw new Error("Invalid date format");
    }

    return date.format('HH:mm');
}

export const formatToWeekdayNumber = (dateString: string|null): number => {
  if(dateString ==null){
    return null;
  }
    const date = dayjs(dateString);

  if (!date.isValid()) {  
      throw new Error("Invalid date format");
  }

    return date.day(); 
};

export const convertToDateTime = (time: string, dayNumber: number, year: string = '2025', month: string = '01'): string => {
    const date = dayjs(`${year}-${month}-${dayNumber}`);
    
    if (!date.isValid()) {
        throw new Error("Invalid day number");
    }

    const formattedDateTime = `${date.format('YYYY-MM-DD')}T${time}:00Z`;
    const dateTime = dayjs(formattedDateTime);

    if (!dateTime.isValid()) {
        throw new Error("Invalid time format");
    }

    console.log(dateTime.toISOString())
    return dateTime.toISOString();
};

export const getDayName = (dayNumber: number): string => {
    const date = dayjs().day(dayNumber);
    return date.format('dddd');
};

export const filterWorkTimesByDay = (dayNumber: number, workTimes: IWorkTime[]): IWorkTime[] => {
    return workTimes.filter((workTime) => {
      const startDay = dayjs(workTime.startTime).day(); 
      const endDay = dayjs(workTime.endTime).day();   
  
      return startDay === dayNumber || endDay === dayNumber;
    });
  };

  export const groupedWorkTimesByDay = (
    dayNumber: number,
    workTimes: IWorkTime[]
  ): { startTime: string; endTime: string }[] => {
    return workTimes
      .filter((workTime) => {
        const startDay = dayjs.utc(workTime.startTime).day(); 
        const endDay = dayjs.utc(workTime.endTime).day(); 
  
        return startDay === dayNumber || endDay === dayNumber;
      })
      .map((workTime) => {
        const newWorkTime: IWorkTime = {
          startTime: dayjs.utc(workTime.startTime).format("HH:mm"),
          endTime: dayjs.utc(workTime.endTime).format("HH:mm"),
        };
        return newWorkTime;
      })
      .sort((a, b) => {
        const timeA = dayjs(a.startTime, "HH:mm");
        const timeB = dayjs(b.startTime, "HH:mm");
        return timeA.isBefore(timeB) ? -1 : 1;
      });
  };
  
  
  export const getDisabledRanges = (workTimes: IWorkTime[] = [], startTime: string | null = null) => {
    if (!Array.isArray(workTimes) || workTimes.length === 0) {
      return {
        disabledHours: [],
        disabledMinutes: () => [],
      };
    }
  
    const disabledHours: Set<number> = new Set();
    const disabledMinutes: Record<number, Set<number>> = {};
  
    const startTimeMoment = startTime ? dayjs(startTime, "HH:mm") : null;
  
    workTimes.forEach(({ startTime, endTime }) => {
      const start = dayjs.utc(startTime);
      const end = dayjs.utc(endTime);
  
      if (startTimeMoment && end.isBefore(startTimeMoment)) {
        return; 
      }
  
      for (let hour = start.hour(); hour <= end.hour(); hour++) {
        if (!disabledMinutes[hour]) {
          disabledMinutes[hour] = new Set();
        }
        const startMinute = hour === start.hour() ? start.minute() : 0;
        const endMinute = hour === end.hour() ? end.minute() : 59;
  
        for (let minute = startMinute; minute <= endMinute; minute++) {
          disabledMinutes[hour].add(minute);
        }
      }
    });
  
    Object.entries(disabledMinutes).forEach(([hour, minutes]) => {
      if (minutes.size === 60) {
        disabledHours.add(Number(hour));
      }
    });
  
    return {
      disabledHours: Array.from(disabledHours),
      disabledMinutes: (selectedHour: number) => Array.from(disabledMinutes[selectedHour] || []),
    };
  }; 

  export const isToday = (dateString: string): boolean => {
    const date = dayjs.utc(dateString);
    return date.isSame(dayjs.utc(), "day");
  };

  export const isYesterday = (dateString: string): boolean => {
    const date = dayjs.utc(dateString);
    return date.isSame(dayjs.utc().subtract(1, "day"), "day");
  };

  export const getDayNameFromDate = (dateString: string): string => {
    const date = dayjs.utc(dateString);
    return date.format("dddd");
  };
  